export type ServiceUnavailableTranslation = {
  message: string;
};

export const serviceUnavailableTranslation: ServiceUnavailableTranslation = {
  message: 'Nie przyjmujemy teraz zgłoszeń na praktyki, zapraszamy w marcu',
};
